import styled from "@emotion/styled";
import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";

import React, { Children, useState } from "react";

function TabContent({ value, index, children }) {
    return value === index ? children : "";
}


const Tabselectedcolor = styled(Tab)(({ selectedcolor, colort }) => ({
    "&.Mui-selected, &.Mui-selected:hover": {
        color: colort || "white",
        backgroundColor: selectedcolor
    }
}));

export default function TabContainer({ children, sx, tab, changeTab, ...props }) {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [value, setValue] = useState(0);

    function handleChange(event, newValue) {
        if (changeTab) {
            changeTab(newValue)
        }
        setValue(newValue);
    }



    children = Children.toArray(children);
    const tabs = [];

    for (const child of children) {
        if (child.props.label) {
            tabs.push(child.props.label);
        }
    }
    const atualTab = tab !== undefined ? tab : value
    return (
        <Box sx={{ width: "100%", ...sx }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={atualTab} onChange={handleChange}
                    textColor="inherit"
                    variant={smallScreen ? "fullWidth" : "standard"} {...props}>
                    {tabs.map((tab) => (
                        <Tabselectedcolor selectedcolor={theme.palette.primary.main} label={tab} key={tab} />
                    ))}
                </Tabs>
            </Box>

            {children.map((child, index) => (
                <TabContent value={atualTab} index={index} key={index}>
                    {child}
                </TabContent>
            ))}
        </Box>
    );
}
